import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
//   Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from "react-helmet";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

// import  logo from "../images/Flavrapogi-Logo.png";

const Cancellation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Helmet>
        <title>Cancellation & Refund Policy | Flavrapogi</title>
        <meta
          name="description"
          content="Read the Cancellation and Refund Policy of Flavrapogi."
        />
      </Helmet>

      <Container
        maxWidth="100vw"
        sx={{
          py: 6,
          minHeight: "100vh",
          background: `radial-gradient(circle at 50% 50%, rgb(1, 246, 230) 0%, rgb(0, 251, 255) 25%, rgb(6, 54, 183) 50%, rgb(0, 0, 0) 75%, rgba(0, 0, 0, 0.83) 100%)`,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            color: "white",
            mb: 5,
            mt: 4,
          }}
        >
          {/* <Avatar
            src={logo}
            sx={{
              width: isMobile ? 80 : 100,
              height: isMobile ? 80 : 100,
              mb: 2,
              boxShadow: theme.shadows[8],
            }}
          /> */}

          <Typography
            variant={isMobile ? "h4" : "h3"}
            sx={{
              fontWeight: 700,
              mb: 1,
            }}
          >
            Cancellation & Refund Policy
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "rgba(255,255,255,0.9)",
            }}
          >
            FLAVR APOGI HEALTHCARE AND INDUSTRIAL CATERING SERVICES PRIVATE
            LIMITED
          </Typography>
        </Box>

        {/* Content */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Paper
            elevation={6}
            sx={{
              width: "100%",
              maxWidth: "1200px",
              p: { xs: 3, md: 5 },
              borderRadius: 4,
              backgroundColor: "rgba(255,255,255,0.96)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 3,
              }}
            >
              <CancelOutlinedIcon
                color="error"
                sx={{ fontSize: 40 }}
              />

              <Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700 }}
                >
                  Cancellation & Refund Policy
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Last updated on April 1, 2025
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ mb: 4 }} />

            <Typography
              variant="body1"
              sx={{
                mb: 3,
                lineHeight: 1.9,
                fontSize: "1rem",
              }}
            >
              No cancellations and refunds are entertained for any purchases
              made through our website or services.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 3,
                lineHeight: 1.9,
                fontSize: "1rem",
              }}
            >
              FLAVR APOGI HEALTHCARE AND INDUSTRIAL CATERING SERVICES PRIVATE
              LIMITED does not offer cancellations or refunds for any purchases
              made through our platform.
            </Typography>

            <Paper
              elevation={0}
              sx={{
                p: 3,
                mt: 4,
                borderRadius: 3,
                backgroundColor: "rgba(0,0,0,0.04)",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Contact Us
              </Typography>

              <Typography
                variant="body1"
                sx={{ mb: 1 }}
              >
                For any exceptional circumstances, please contact us directly:
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  mb: 1,
                }}
              >
                Email: flavrapogi@gmail.com
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                }}
              >
                Phone: 9840110545
              </Typography>
            </Paper>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default Cancellation;